var _path, _rect, _circle, _circle2, _ellipse, _line, _text, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_919",
    "data-name": "Group 919",
    xmlns: "http://www.w3.org/2000/svg",
    width: 623.461,
    height: 307.026,
    viewBox: "0 0 623.461 307.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2081",
    "data-name": "Path 2081",
    d: "M42,0H581.324a42,42,0,0,1,42,42V307.026H0V42A42,42,0,0,1,42,0Z",
    fill: "#363739"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_625",
    "data-name": "Rectangle 625",
    width: 448.677,
    height: 39.391,
    rx: 19.695,
    transform: "translate(130.427 25.385)",
    fill: "#3e3f41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_136",
    "data-name": "Ellipse 136",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(30 34.026)",
    fill: "#fb605b"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_137",
    "data-name": "Ellipse 137",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(57 34.026)",
    fill: "#fdbc40"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_138",
    "data-name": "Ellipse 138",
    cx: 9.5,
    cy: 10,
    rx: 9.5,
    ry: 10,
    transform: "translate(84 34.026)",
    fill: "#34c849"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_299",
    "data-name": "Line 299",
    x2: 623.023,
    transform: "translate(0.438 87.415)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "https:_YourBrand.3dlayers.app",
    "data-name": "https://YourBrand.3dlayers.app",
    transform: "translate(156.418 49.014)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "https://mybrand.3dlayers.app"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2432",
    "data-name": "Group 2432",
    transform: "translate(159.097 130.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2431",
    "data-name": "Group 2431",
    transform: "translate(159.903)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1128",
    "data-name": "Rectangle 1128",
    width: 162,
    height: 135,
    rx: 36,
    transform: "translate(0 0.217)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_160",
    "data-name": "Ellipse 160",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(21 19.217)",
    fill: "#24d2c1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_355",
    "data-name": "Line 355",
    x2: 47.088,
    transform: "translate(56.95 33.36)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_161",
    "data-name": "Ellipse 161",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(21 88.217)",
    fill: "#ee6575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1917",
    "data-name": "Path 1917",
    d: "M0,0H32.414",
    transform: "translate(56.95 67.77)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_162",
    "data-name": "Ellipse 162",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(21 55.217)",
    fill: "#fe0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_357",
    "data-name": "Line 357",
    x2: 64.293,
    transform: "translate(56.95 102.18)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2440",
    "data-name": "Group 2440",
    transform: "translate(-15.916 17.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    d: "M177.533,219.3c-9.394-8.606-30.584-8.71-40.066-.222-4.773,4.275-4.773,9.989-.047,14.335a19.8,19.8,0,0,0,2.8,2.084c9.385-5.694,25.1-5.619,34.376.2a19.219,19.219,0,0,0,2.856-2.051C182.255,229.335,182.274,223.638,177.533,219.3Z",
    transform: "translate(-83.354 -186.661)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1937",
    "data-name": "Path 1937",
    d: "M156.479,216.889l-15.651-9.139L125.7,216.4l15.621,9.135a10.107,10.107,0,0,0-.833.835,23.465,23.465,0,0,0-5.282,7.584l-7.927-.05-14.247-.078-.047,12.331,22.187.11a17.466,17.466,0,0,0,1.566,3.1,25.022,25.022,0,0,0,4.43,5.4l-15.729,8.956,1.672.994,13.084,7.644.308.162,15.714-8.962c1.411.526,2.882.979,4.348,1.413a72.461,72.461,0,0,0,10.259,2.157l-.024,3.76-.028,9.049,21.341.116.056-9.059.017-3.742a76.239,76.239,0,0,0,10.28-2.051c1.493-.418,2.944-.865,4.359-1.376l15.608,9.152.3-.147,13.192-7.53,1.682-.964L221.972,255.2a25.526,25.526,0,0,0,4.491-5.367,18.067,18.067,0,0,0,1.62-3.056l22.2.112.047-12.323-14.253-.086-7.931-.026a22.826,22.826,0,0,0-5.166-7.623c-.3-.289-.552-.6-.854-.858L237.849,217l-15.028-8.8-15.735,8.977a68.578,68.578,0,0,0-14.639-3.574l.091-12.817-21.345-.114-.08,12.815A70.428,70.428,0,0,0,156.479,216.889Zm45.148,30.761a19.216,19.216,0,0,1-2.856,2.051c-9.338,5.705-25.055,5.612-34.376-.2a19.8,19.8,0,0,1-2.8-2.084c-4.726-4.346-4.726-10.06.047-14.335,9.482-8.488,30.672-8.384,40.066.222,4.744,4.341,4.725,10.038-.081,14.345Z",
    transform: "translate(-107.532 -200.668)",
    fill: "#24d2c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    d: "M118.812,229.9l15.064,8.8-.132,18.482-15.032-8.792Z",
    transform: "translate(-100.904 -166.853)",
    fill: "#16a89f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1939",
    "data-name": "Path 1939",
    d: "M141.526,229.82l-.1,18.478-15.746,8.967.132-18.482Z",
    transform: "translate(-92.841 -166.94)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1940",
    "data-name": "Path 1940",
    d: "M161.168,237.531,161.1,256l-21.368-.1.1-18.49Z",
    transform: "translate(-76.588 -158.155)",
    fill: "#16a89f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1941",
    "data-name": "Path 1941",
    d: "M147.687,233.39l-.093,18.472A70.875,70.875,0,0,1,132.98,248.3l.1-18.477C137.461,231.692,147.687,233.39,147.687,233.39Z",
    transform: "translate(-84.396 -166.94)",
    fill: "#16a89f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1942",
    "data-name": "Path 1942",
    d: "M135.229,221.865l-.09,11.952-9.641,5.5v.986l-12.565-.08.111-18.463Z",
    transform: "translate(-107.59 -176.27)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1943",
    "data-name": "Path 1943",
    d: "M123.319,221.806a23.631,23.631,0,0,0,6,8.492l-6.087,3.46Z",
    transform: "translate(-95.68 -176.212)",
    fill: "#16a89f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1944",
    "data-name": "Path 1944",
    d: "M172.144,239.1l-.068,18.469-15.624-9.138.084-18.484Z",
    transform: "translate(-57.242 -166.798)",
    fill: "#16a89f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1945",
    "data-name": "Path 1945",
    d: "M178.937,230.18l-.078,18.492-15.164,8.617.068-18.469Z",
    transform: "translate(-48.861 -166.523)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1946",
    "data-name": "Path 1946",
    d: "M164.4,229.971c.073-1.2-.084,18.483-.084,18.483a65.412,65.412,0,0,1-14.655,3.412c0-1.1.1-18.468.1-18.468a79.349,79.349,0,0,0,14.639-3.427Z",
    transform: "translate(-65.102 -166.826)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1947",
    "data-name": "Path 1947",
    d: "M188.58,222.155l-.116,18.486-12.554-.074v-.973l-9.6-5.614.074-11.937Z",
    transform: "translate(-45.834 -175.937)",
    fill: "#16a89f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1948",
    "data-name": "Path 1948",
    d: "M169.623,222.043l-.073,11.939-6.037-3.516a26.954,26.954,0,0,0,6.11-8.423Z",
    transform: "translate(-49.072 -175.938)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1949",
    "data-name": "Path 1949",
    d: "M179.31,208.238l-.084,17.547-9.624-.093a24.279,24.279,0,0,0-6.02-8.481Z",
    transform: "translate(-48.992 -191.91)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1950",
    "data-name": "Path 1950",
    d: "M134.558,217.094a25.543,25.543,0,0,0-6.115,8.419l-9.614-.058.108-17.5Z",
    transform: "translate(-100.769 -192.232)",
    fill: "#0a8074"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.9b5ccf14e4869e7b941eda8228db1952.svg";
export { ForwardRef as ReactComponent };